import { useToggle } from "@react-hookz/web";
import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { computeGaLabelSharingUrl } from "~/components/content/content-share-widget/helpers";
import IconShare from "~/components/header/header-icon/share.svg";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { currentArticleAtom } from "~/lib/current-item";

import { StyledDynamicContentShareWidget, StyledDynamicDrawer } from "./styles";

export const HeaderContentShareWidgetDrawer: FunctionComponent = () => {
  const currentArticle = useAtomValue(currentArticleAtom);
  const [isOpenDrawer, setIsOpenDrawer] = useToggle(false);

  if (!currentArticle) return null;

  const { sharingUrl } = computeGaLabelSharingUrl(currentArticle);
  return (
    <>
      <IconShare
        height={16}
        width={16}
        onClick={() => {
          sendGATracking({
            action: "Share menu button/Click",
            category: "Share button (Adhesive)",
            label: sharingUrl,
          });
          setIsOpenDrawer(true);
        }}
      />
      <StyledDynamicDrawer
        anchor="bottom"
        open={isOpenDrawer}
        PaperProps={{
          sx: {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
        }}
        title="Share"
        withClose
        onClose={() => setIsOpenDrawer(false)}
      >
        <StyledDynamicContentShareWidget
          extraProps={{
            copyLink: {
              variant: "label",
            },
          }}
          position="article_adhesive"
          reference={currentArticle}
          style={{
            /* stylelint-disable-next-line csstree/validator */
            size: "48px",
          }}
          types={[
            "facebook",
            "twitter",
            "whatsapp",
            "email",
            "messenger",
            "line",
            "telegram",
            "copy-link",
          ]}
          showLabel
          onClick={() => setTimeout(() => setIsOpenDrawer(false), 1000)}
        />
      </StyledDynamicDrawer>
    </>
  );
};

HeaderContentShareWidgetDrawer.displayName = "HeaderContentShareWidgetDrawer";
